/**
 * Quick Action Buttons for "The Liner Notes" section
 *
 * Makes buttons functional for quick add-to-cart based on button text.
 * Looks for buttons with text "Add to cart" and "Subscribe" within
 * The Liner Notes section.
 *
 * Used by: templates/product.coffee-quick-actions.json
 */

// Run immediately since script is deferred (DOM is already ready)
(function() {
  // Find The Liner Notes section
  const linerNotesSection = document.querySelector('[id*="section_custom_content_N6kgeN"]');
  if (!linerNotesSection) {
    console.log('Quick Actions: Liner Notes section not found');
    return;
  }

  // Find buttons by their text content within The Liner Notes section
  const buttons = linerNotesSection.querySelectorAll('.btn');
  let addToCartBtn = null;
  let subscribeBtn = null;

  buttons.forEach(btn => {
    const text = btn.textContent.trim().toLowerCase();
    if (text === 'add to cart') {
      addToCartBtn = btn;
    } else if (text === 'subscribe') {
      subscribeBtn = btn;
    }
  });

  // Set up "Add to cart" button (one-time purchase)
  if (addToCartBtn) {
    addToCartBtn.addEventListener('click', (e) => {
      e.preventDefault();
      e.stopPropagation();
      const formData = getProductFormData();
      if (formData) {
        addToCartQuickAction(formData, addToCartBtn);
      }
    });
    console.log('Quick Actions: Add to cart button ready');
  }

  // Set up "Subscribe" button (subscription purchase)
  if (subscribeBtn) {
    subscribeBtn.addEventListener('click', (e) => {
      e.preventDefault();
      e.stopPropagation();
      const formData = getProductFormData();
      if (!formData) return;

      // Get selling plan ID
      let sellingPlanId = document.querySelector('input[name="selling_plan"]')?.value;

      // If no plan selected, get the default from Recharge widget
      if (!sellingPlanId) {
        const rechargeWidget = document.querySelector('.recharge-subscription-widget');
        if (rechargeWidget) {
          const firstPlanInput = rechargeWidget.querySelector('input[type="radio"][name*="selling_plan"]:checked') ||
                                 rechargeWidget.querySelector('input[type="radio"][name*="selling_plan"]') ||
                                 rechargeWidget.querySelector('input[name*="selling_plan"]');
          sellingPlanId = firstPlanInput?.value;
        }
      }

      if (sellingPlanId) {
        formData.selling_plan = parseInt(sellingPlanId);
        addToCartQuickAction(formData, subscribeBtn);
      } else {
        alert('No subscription plan available. Please select a subscription option above.');
      }
    });
    console.log('Quick Actions: Subscribe button ready');
  }

  // Get variant ID and quantity from the product form
  function getProductFormData() {
    const variantInput = document.querySelector('form.shopify-product-form input[name="id"]');
    const quantityInput = document.querySelector('input[name="quantity"]');

    if (!variantInput || !variantInput.value) {
      console.error('No variant selected');
      alert('Please select product options first');
      return null;
    }

    return {
      id: parseInt(variantInput.value),
      quantity: parseInt(quantityInput?.value) || 1
    };
  }

  // Add to cart via AJAX
  function addToCartQuickAction(data, button) {
    const originalText = button.textContent;
    button.classList.add('is-loading');
    button.setAttribute('disabled', 'true');
    button.textContent = 'Adding...';

    fetch('/cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'X-Requested-With': 'XMLHttpRequest'
      },
      body: JSON.stringify(data)
    })
    .then(response => response.json())
    .then(result => {
      if (result.status === 422 || result.status === 'error') {
        // Error - item couldn't be added
        alert(result.description || result.message || 'Could not add to cart');
        button.textContent = originalText;
      } else {
        // Success - trigger cart drawer refresh
        document.dispatchEvent(new CustomEvent('theme:cart:refresh'));

        // Show success feedback
        button.textContent = 'Added!';
        setTimeout(() => {
          button.textContent = originalText;
        }, 2000);
      }
    })
    .catch(error => {
      console.error('Add to cart error:', error);
      alert('Error adding to cart. Please try again.');
      button.textContent = originalText;
    })
    .finally(() => {
      button.classList.remove('is-loading');
      button.removeAttribute('disabled');
    });
  }
})();
